import { Layout, List } from '@/views/postechs'

export default {
  path: 'postechs',
  //name: 'customers_list',
  component: Layout,
  children: [
    { path: '', redirect: { name: 'postechs_list' } },
    { path: 'list', name: 'postechs_list', component: List }
    /* {
            path: ':id',
            name: 'customer_details',
            component: Details,
            props: (route) => {
                return { ...route.params, ...{ customerId: Number.parseInt(route.params.id, 10) || undefined } }
            }
        }*/
    // { path: 'add', component: AddEdit },
    // { path: 'edit/:id', component: AddEdit }
  ]
}
